<template>
  <div class="affair-container">
    <template v-if="viewType === 'list'">
<!--      <search-tabs @change="tabTypeChange"></search-tabs>-->

      <search-box ref="search" :status-list="statusList" @change="research"></search-box>

      <div class="contentBox">
        <div  class="contentTable">
          <el-table size="medium"
                    :data="tableData">
            <el-table-column
                    prop="flowNo"
                    label="流程编号"
                    width="180">
            </el-table-column>
            <el-table-column
                    prop="typeName"
                    label="类型"
                    width="180">
            </el-table-column>
            <el-table-column
                    prop="applyUserName"
                    label="申请人">
            </el-table-column>
            <el-table-column
                    prop="description"
                    label="描述">
            </el-table-column>
            <el-table-column
                    prop="submitTime"
                    label="申请时间">
            </el-table-column>
            <el-table-column
                    prop="userList[0].name"
                    label="上节点提交人">
            </el-table-column>
            <el-table-column
                    prop="dealTime"
                    label="上节点提交时间">
            </el-table-column>
            <el-table-column
                    prop="status"
                    label="状态">
              <template slot-scope="scope">
                <span class="status" :class=[$reconava.getStatusClass(scope.row.status)]>
                  {{$reconava.getStatusName(scope.row.status)}}</span>
              </template>
            </el-table-column>
            <el-table-column width="100" label="操作">
              <template slot-scope="scope">
                <span @click="see(scope.row,'todo')" class="blue">审核</span>
              </template>
            </el-table-column>
          </el-table>
          <ReconovaPagination
              v-if="tableData.length > 0"
              @paginationChange="paginationChange"
              :page-no="search.pageNum"
              :page-size="search.pageSize"
              :total="total"
          >
          </ReconovaPagination>
        </div>
      </div>
    </template>

    <template v-else-if="viewType === 'see'">
      <!--  detail handle    -->
      <check-detail @cancel="close" type="check" :id="currentId" :taskId="taskId" from="todo"></check-detail>
    </template>

    <template v-else-if="viewType === 'approvalDetail'">
      <approval-detail @changeType="close" type="agent" :id="currentId" :taskId="taskId" ></approval-detail>
    </template>

    <template v-else-if="viewType === 'flowDetail'">
      <flow-detail @changeType="close" type="agent" :id="currentId" :taskId="taskId" ></flow-detail>
    </template>

    <template v-else-if="viewType === 'contractDetail'">
      <labor-contract-detail @changeType="close" :taskId="taskId"></labor-contract-detail>
    </template>

    <template v-else-if="viewType === 'positiveDetail'">
      <positive-detail @changeType="close" :taskId="taskId"></positive-detail>
    </template>

    <template
      v-else-if="['dynamicFormDetail', 'dynamicFormEdit'].includes(viewType)"
    >
      <dynamic-form-wrapper
        :id="currentId"
        :taskId="taskId"
        :viewType="viewType"
        @changeType="close"
        :showHistory="true"
      ></dynamic-form-wrapper>
    </template>

  </div>
</template>

<script>
  import SearchBox from "./searchBox";
  import ReconovaPagination from "@/components/reconova/reconovaPagination";
  import SearchTabs from "./searchTabs";
  import mixins from "./components/mixins";
  import {waitList} from "../../../services/checkModule";
  import LaborContractDetail from "../../businessModule/personnel/labor-contract/detail";
  import PositiveDetail from "../../businessModule/personnel/positive/detail";
  import CheckDetail from "../../businessModule/examine/formDetail/checkDetail";
  import DynamicFormWrapper from "./components/dynamicFormWrapper.vue";
  export default {
    name: "agent",
    components: {CheckDetail, PositiveDetail, LaborContractDetail, SearchTabs, ReconovaPagination, SearchBox, DynamicFormWrapper },
    mixins: [ mixins ],
    data() {
      return {
        currentId:'',//数据编号
        taskId:'',//处理任务id
        viewType:'list',
        statusList: [{label:"全部",value:"0"},{label:"已超时",value:"1"},{label:"即将超时",value:"2"}],
        search:{pageNum:1,pageSize:20},
        tableData:[],
        total:0
      }
    },
    methods: {
      close(){
        this.viewType = 'list';
        this.$nextTick(()=>{
          this.getData()
        })
      },

      research(){
        this.search.pageNum = 1;
        this.getData()
      },
      //获取列表数据
      getData(){
        let search = Object.assign(this.search,this.$refs.search.getQuery());
        search.keyList =
        (search.keyList && search.keyList.join && search.keyList.join(",")) ||
        "";
        waitList(search).then(res => {
          this.tableData = res.data.list.map(item => {
          return {
            ...item,
            description: item.content ? item.content.description : '',
          }
        });
          this.total = res.data.total
        })
      },
      //翻页
      paginationChange(type, val) {
        if (type === "pageNo") {
          this.search.pageNum = val;
        } else {
          this.search.pageNum = 1;
          this.search.pageSize = val;
        }
        this.getData()
      },
    },
    mounted() {
      this.getData()
    }
  }
</script>

<style scoped>
@import "css/examine.scss";
</style>
